import React from 'react';
import { UsersIcon } from 'lucide-react';
import type { Team, MetricType, PeriodInfo } from '../../types';
import { ProgressBar } from '../ui/ProgressBar';
import { Badge } from '../ui/Badge';
import { LoanOfficerRow } from './LoanOfficerRow';
import { aggregateTeamMetrics, getProgressPercentage, getProgressStatus, calculateProjection } from '../../utils/calculations';
interface TeamSectionProps {
  team: Team;
  period: PeriodInfo;
  metric: MetricType;
}
export function TeamSection({
  team,
  period,
  metric
}: TeamSectionProps) {
  const {
    current,
    goal
  } = aggregateTeamMetrics(team, metric);
  const percentage = getProgressPercentage(current, goal);
  const projected = calculateProjection(current, period.daysElapsed, period.totalDays);
  const projPct = getProgressPercentage(projected, goal);
  const status = getProgressStatus(projPct);
  return <div className="ml-4 border-l-2 border-gray-200 pl-4 mb-4 last:mb-0" data-id="element-74">
      {/* Team Header */}
      <div className="flex items-center gap-4 py-3 px-4 bg-gray-50 rounded-lg mb-1" data-id="element-75">
        <div className="flex items-center gap-2.5 w-44 flex-shrink-0" data-id="element-76">
          <div className="w-7 h-7 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0" data-id="element-77">
            <UsersIcon className="w-3.5 h-3.5 text-blue-600" data-id="element-78" />
          </div>
          <div className="min-w-0" data-id="element-79">
            <p className="text-sm font-semibold text-gray-900 truncate" data-id="element-80">
              {team.name}
            </p>
            <p className="text-xs text-gray-500 truncate" data-id="element-81">{team.managerName}</p>
          </div>
        </div>

        <div className="flex-1 min-w-0" data-id="element-82">
          <ProgressBar current={current} goal={goal} size="sm" showLabel={false} data-id="element-83" />
        </div>

        <div className="w-20 text-right flex-shrink-0" data-id="element-84">
          <span className="text-sm font-semibold text-gray-900" data-id="element-85">{current}</span>
          <span className="text-sm text-gray-400" data-id="element-86"> / {goal}</span>
        </div>

        <div className="w-16 text-right flex-shrink-0" data-id="element-87">
          <span className="text-sm font-medium text-gray-700" data-id="element-88">
            {percentage}%
          </span>
        </div>

        <div className="w-48 flex-shrink-0 hidden lg:block" data-id="element-89" />

        <div className="w-24 flex-shrink-0 flex justify-end" data-id="element-90">
          <Badge status={status} size="sm" data-id="element-91" />
        </div>
      </div>

      {/* Loan Officers */}
      <div className="bg-white rounded-lg border border-gray-100 overflow-hidden" data-id="element-92">
        {team.loanOfficers.map(lo => <LoanOfficerRow key={lo.id} loanOfficer={lo} period={period} metric={metric} data-id="element-93" />)}
      </div>
    </div>;
}